import { CheckinOrderFragment, CheckoutOrderFragment, GdsServiceVipSubType, NASProductType } from '@websky/graphql';
import { FetchResult } from 'apollo-boost';

export interface InitialParams {
	currency?: string;
	coupon?: string;
}

export type FlightNumber = string;
export type FlightDirection = string;
export type FlightDeparture = string;

export enum ItemCategory {
	// GDS service category
	PriceFreeze = 'hold',
	Meal = 'meal',
	Flight = 'flight',
	Seat = 'seat',
	Baggage = 'baggage',
	Insurance = 'insurance',
	Aeroexpress = 'aeroexpress',
	Pets = 'pets',
	Business = 'business hall',
	// NAS service category
	NASVipLounge = 'vip_lounge',
	NASBusinessLounge = 'business_lounge',
	NASMeetAndGreat = 'meet_and_greet'
}

export enum Recommendation {
	Recommended = 'recommended',
	NoRecommended = 'no recommendation'
}

export interface ViewListItem {
	item_id: FlightNumber;
	item_name?: string;
	item_category4: FlightDeparture;
	item_brand: FlightDirection;
	item_category: ItemCategory;
	item_category2?: OrderStep;
	item_category3?: Recommendation;
	item_category5?: string[];
	price?: number;
	quantity?: number;
	index?: number;
	currency?: string;
	coupon?: string;
}

export enum OrderStep {
	Booking = 'booking',
	Checkout = 'checkout',
	Paid = 'paid',
	Checkin = 'check in'
}

export enum PurchaseShowPopupAction {
	Decline = 'decline',
	Add = 'add',
	Change = 'change'
}

export enum DataLayerEvent {
	ViewItemList = 'view_item_list',
	ViewItem = 'view_item',
	AddToCart = 'add_to_cart',
	RemoveFromCart = 'remove_from_cart',
	Checkout = 'begin_checkout',
	Purchase = 'purchase',
	PurchaseShowPopup = 'purchase_show_popup',
	QueryShowPopup = 'query_show_popup'
}

export enum DataLayerItemsListName {
	SearchResults = 'Search results',
	Fares = 'Tariffs',
	Seats = 'Seats',
	Baggage = 'Baggage options',
	Meal = 'Meals',
	Insurance = 'Insurance options',
	Aeroexpress = 'Aeroexpress options',
	Pets = 'Pets options',
	Business = 'Business hall options'
}

export interface DataLayerEcommerce {
	value?: number;
	currency?: string;
	coupon?: string;
	transaction_id?: string;
	item_list_name?: DataLayerItemsListName;
	items: ViewListItem[];
}

export interface DataLayerEventType {
	event?: DataLayerEvent;
	ecommerce: DataLayerEcommerce | null;
}

export enum WxEvents {
	PriceFreeze,
	MealItem,
	MealsList,
	AeroexpressList,
	PetsList,
	InsurancesList,
	BaggageList,
	BaggageItem,
	SeatsList,
	VipList,
	NASVipList,
	NASVipItem,
	BusinessLoungeList,
	AiPurchaseModalOpen,
	AiPurchaseModalClose
}

export type WxEventOptions = {
	servicesIds?: string[];
	segmentId?: string;
	subType?: GdsServiceVipSubType | string;
	nasType?: NASProductType;
};

export type WxEvent = {
	itemCategory: WxEvents;
	options?: WxEventOptions;
};

export type ApolloResponse = FetchResult<{ [key: string]: any }, Record<string, any>, Record<string, any>>;

export type CheckoutCheckinOrder = CheckoutOrderFragment | CheckinOrderFragment;
